import { Helmet } from 'react-helmet';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import {
  Box, Button, Container, Card, CardContent, TextField, SvgIcon, InputAdornment
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Search as SearchIcon } from 'react-feather';
import Modal from '@material-ui/core/Modal';
import {
  SEARCH_DASBOARD_API,
  SEARCH_DASBOARD_ID_API,
  COLLECTIBLE_PAGING_API,
} from "../apiContants";

/* eslint-disable camelcase */
// function rand() {
//   return Math.round(Math.random() * 20) - 10;
// }
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `40%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  roots: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    height: "25px!important",
    paddingTop: "5px!important",
  },
  padding: {
    paddingTop: "15px!important",
  },
  select: {
    color: "white!important",
  },
  containt: {
    marginTop: "30px!important",
  },
  buttonsearch: {
    marginTop: "15px!important",
    marginLeft: "15px!important",
  },
  buttonclear: {
    marginTop: "15px!important",
    // marginLeft: '15px!important',
  },
  buttonshow: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    // color: theme.palette.text.primary,
    // backgroundColor: '#5664d2!important',
    backgroundColor: "#5664d2!important",
    color: "white!important",
    borderRadius: "0px!important",
    // height: '25px!important',
  },
  papervalue: {
    padding: theme.spacing(2),
    border: "1px solid blue!important",
    textAlign: "center",
    color: "black!important",
    borderRadius: "0px!important",
  },
  modal: {
    position: "absolute",
    width: 900,
    height: 600,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // textAlign: 'center',
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const [reg, regSet] = useState(Array);
  const [regCreator, regCreatorSet] = useState(Array);
  const [regOwner, regOwnerSet] = useState(Array);
  const [regBought, regBoughtSet] = useState(Array);
  const [regSold, regSoldSet] = useState(Array);
  const [value, setValues] = React.useState({
    name: "",
  });
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [datas, setDatas] = React.useState(0);

  const handleChange = (event, newValue) => {
    setDatas(newValue);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeForm = (name) => (event) => {
    setValues({ ...value, [name]: event.target.value });
  };
  const handleKeyPress = async (event) => {
    if (event.charCode === "13") {
      const total_mint = await axios.get(SEARCH_DASBOARD_API + value.name);
      const data = total_mint.data.accounts[0];
      regSet(data);
    }
  };
  const dynamicSearch = async () => {
    const query = window.location.href;
    const result = query?.substring(query.indexOf("="));
    const hasNumber = /\d/;
    const hasNumberCheck = hasNumber.test(query);
    if (query.indexOf("id") > 0) {
      try {
        const getid = await axios.get(SEARCH_DASBOARD_ID_API + result);
        const regs = getid.data;
        regSet(regs);
      } catch {
        console.log("Error loaidng rejected data");
      }
    }
  };
  const totalmint_volume = async () => {
    const total_mint = await axios.get(SEARCH_DASBOARD_ID_API + value.name);
    const data = total_mint.data;
    regSet(data);
  };

  const getPaging = async () => {
    const creator = await axios.get(
      COLLECTIBLE_PAGING_API + value.name + `&options=creator`
    );
    const owner = await axios.get(
      COLLECTIBLE_PAGING_API + value.name + `&options=owner`
    );
    const bought = await axios.get(
      COLLECTIBLE_PAGING_API + value.name + `&options=bought`
    );
    const sold = await axios.get(
      COLLECTIBLE_PAGING_API + value.name + `&options=sold`
    );
    regCreatorSet(creator.data.collectibles);
    regOwnerSet(owner.data.collectibles);
    regBoughtSet(bought.data.collectibles);
    regSoldSet(sold.data.collectibles);
  };
  const clear = () => {
    regSet(undefined);
  };
  useEffect(() => {
    dynamicSearch();
  }, []);
  const body = (
    <Box>
      <div style={modalStyle} className={classes.modal}>
        <h2>Item list of ID : {reg?.address} </h2>
        <Grid className={classes.containt} spacing={3} container>
          <Grid className={classes.padding} item xs={12}>
            <div className={classes.roots}>
              <AppBar position="static">
                <Tabs
                  value={datas}
                  onChange={handleChange}
                  aria-label="simple tabs "
                >
                  <Tab
                    className={classes.select}
                    label="Created Items"
                    {...a11yProps(0)}
                  />
                  <Tab
                    className={classes.select}
                    label="Sale On"
                    {...a11yProps(1)}
                  />
                  <Tab
                    className={classes.select}
                    label="Bought Items"
                    {...a11yProps(2)}
                  />
                  <Tab
                    className={classes.select}
                    label="Sold Items"
                    {...a11yProps(3)}
                  />
                </Tabs>
              </AppBar>
              <TabPanel value={datas} index={0}>
                <Grid container>
                  {regCreator.map((cate, i) => (
                    <Grid item xs={3}>
                      <Button href={`/app/item?id=${cate.id}`}>
                        <video
                          autoPlay
                          muted
                          style={{
                            display: "inline-block",
                            height: 140,
                            width: "100%",
                          }}
                          className="view-img"
                          src={cate.upload_file}
                        />
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </TabPanel>
              <TabPanel value={datas} index={1}>
                <Grid container>
                  {regOwner.map((cate, i) => (
                    <Grid item xs={3}>
                      <Button href={`/app/item?id=${cate.id}`}>
                        <video
                          autoPlay
                          muted
                          style={{
                            display: "inline-block",
                            height: 140,
                            width: "100%",
                          }}
                          className="view-img"
                          src={cate.upload_file}
                        />
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </TabPanel>
              <TabPanel value={datas} index={2}>
                <Grid container>
                  {regBought.map((cate, i) => (
                    <Grid item xs={3}>
                      <Button href={`/app/item?id=${cate.id}`}>
                        <video
                          autoPlay
                          muted
                          style={{
                            display: "inline-block",
                            height: 140,
                            width: "100%",
                          }}
                          className="view-img"
                          src={cate.upload_file}
                        />
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </TabPanel>
              <TabPanel value={datas} index={3}>
                <Grid container>
                  {regSold.map((cate, i) => (
                    <Grid item xs={3}>
                      <Button href={`/app/item?id=${cate.id}`}>
                        <video
                          autoPlay
                          muted
                          style={{
                            display: "inline-block",
                            height: 140,
                            width: "100%",
                          }}
                          className="view-img"
                          src={cate.upload_file}
                        />
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </TabPanel>
            </div>
          </Grid>
          <Grid className={classes.padding} item xs={12}></Grid>
        </Grid>
      </div>
    </Box>
  );
  return (
    <>
      <Helmet>
        <title>Customers | Material Kit</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ mt: 3 }}>
            <Card>
              <CardContent>
                <Box sx={{ maxWidth: 800 }}>
                  <Grid spacing={3} container>
                    <Grid className={classes.padding} item xs={8}>
                      <TextField
                        onChange={handleChangeForm("name")}
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SvgIcon fontSize="small" color="action">
                                <SearchIcon />
                              </SvgIcon>
                            </InputAdornment>
                          ),
                        }}
                        placeholder="Enter the wallet address"
                        variant="outlined"
                      >
                        1
                      </TextField>
                    </Grid>
                    <Grid className={classes.padding} item xs={4}>
                      <Button
                        className={classes.buttonclear}
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={() => clear()}
                      >
                        Clear
                      </Button>
                      <Button
                        className={classes.buttonsearch}
                        type="button"
                        variant="contained"
                        color="primary"
                        onKeyPress={handleKeyPress}
                        onClick={() => {
                          totalmint_volume();
                          getPaging();
                        }}
                      >
                        Search
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Box>
          <Box sx={{ pt: 3 }}>
            <Grid spacing={1} container>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Wallet ADD</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.address ? reg.address : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>User Name</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.username?.String ? reg.username.String : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Bio</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.info?.String ? reg.info.String : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Cover photo URL</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.cover?.String ? reg.cover.String : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Avatar photo URL</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.avartar?.String ? reg.avartar.String : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Wallet value</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>----</Paper>
                {regCreator.length > 0 && (
                  <Button onClick={handleOpen}>open</Button>
                )}
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Created Items</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {regCreator.length > 0 ? regCreator.length + " item" : "----"}
                </Paper>
                {regOwner.length > 0 && (
                  <Button onClick={handleOpen}>open</Button>
                )}
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>On Sale Items</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {regOwner.length > 0 ? regOwner.length + " item" : "----"}
                </Paper>
                {regBought.length > 0 && (
                  <Button onClick={handleOpen}>open</Button>
                )}
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Bought Items</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {regBought.length > 0 ? regBought.length + " item" : "----"}
                </Paper>
                {regSold.length > 0 && (
                  <Button onClick={handleOpen}>open</Button>
                )}
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Sold Items</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {regSold.length > 0 ? regSold.length + " item" : "----"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Register date</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>----</Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>User status</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>
                  {reg?.status !== 0 ? "BLOCKED" : "ACTIVE"}
                </Paper>
              </Grid>
              <Grid item xs={3}>
                <Paper className={classes.paper}>Request status</Paper>
              </Grid>
              <Grid className={classes.mui} item xs={9}>
                <Paper className={classes.papervalue}>T.B.D</Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
      <Box textAlign="center">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </Modal>
      </Box>
    </>
  );
};

export default Dashboard;
